<template>
  <div class="upPage_">
    <div v-for="(item, index) in uploadList" :key="'img1' + index">
      <div
        class="upload_"
        v-if="item.type == 'OPC' && (claimStep == '4' || claimStep == '5')"
      >
        <div class="upload_1">
          <div class="MGU_">
            <p>
              {{
                $t('noticeArr[5]') ||
                '是否使用其他健康保险的保单申请过同样的理赔'
              }}
            </p>
            <span
              v-if="MGUChecked"
              class="yes_"
              @click="claimEdit == true ? changeSwitch(false) : ''"
              >{{ $t('noticeArr[7]') || '是' }}
              <div class="boll"></div
            ></span>
            <span
              v-else
              class="yes_ no_"
              @click="claimEdit == true ? changeSwitch(true) : ''"
            >
              <div class="boll boll-no"></div>
              {{ $t('noticeArr[8]') || '否' }}
            </span>
          </div>
          <p class="text_" v-if="MGUChecked">
            {{ $t('noticeArr[6]') || '请提供保险公司名称及保险计划的副本' }}
          </p>
          <div v-if="MGUChecked" class="sign—shangzhuanbiaozhi">
            <cube-upload
              v-if="
                (claimEdit || edit) &&
                preview != true &&
                (claimStep == '4' || step == '2')
              "
              v-model="item.list"
              :simultaneous-uploads="1"
              :process-file="processFile"
              @file-removed="(file) => fileRemove(file, item)"
              @file-submitted="(file) => fileSubmitted(file, item)"
            >
            </cube-upload>
            <div v-else-if="preview">
              <img
                @click="showImagePreview(ele)"
                class="uploadImg"
                v-for="(ele, index) in item.list"
                :key="'base' + index"
                :src="ele.imageUrl"
                alt=""
              />
            </div>
            <div v-else>
              <img
                class="uploadImg"
                v-for="(ele, index) in item.list"
                :key="'base' + index"
                :src="ele.url || ele.base64"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 上面为MGU用户选择上传的文件 -->

      <div class="upload_" v-else>
        <div
          class="upload_1"
          v-if="
            (item.list && item.list.length !== 0) ||
            (step != '3' && claimStep != '5')
          "
        >
          <div
            class="point"
            v-if="type != 'supplyMaterialUpload' && item.isFill == 1"
          ></div>
          <template v-if="preview">
            <div style="margin-bottom: 12px" class="text_ text_1">
              {{ item.text }}
            </div>
          </template>
          <template v-else>
            <div class="text_ text_1">
              {{ item.text }}
              <span class="themeColor" @click="showSample(item)">{{
                $t('form.sample')
              }}</span>
            </div>
            <div class="text_">{{ item.mynote }}</div>
          </template>
          <!-- 上面为头部信息 -->
          <div class="sign—shangzhuanbiaozhi">
            <cube-upload
              v-if="
                (claimEdit || edit) &&
                preview != true &&
                (claimStep == '4' || step == '2')
              "
              v-model="item.list"
              :simultaneous-uploads="1"
              :process-file="processFile"
              @file-removed="(file) => fileRemove(file, item)"
              @file-submitted="(file) => fileSubmitted(file, item)"
            >
            </cube-upload>
            <div v-else-if="preview">
              <img
                @click="showImagePreview(ele)"
                class="uploadImg"
                v-for="(ele, index) in item.list"
                :key="'base' + index"
                :src="ele.imageUrl"
                alt=""
              />
            </div>
            <div v-else>
              <img
                class="uploadImg"
                v-for="(ele, index) in item.list"
                :key="'base' + index"
                :src="ele.url || ele.file.base64"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="outer" v-if="item.showSample">
          <div class="inner">
            <div class="i_div i_div1">
              <span class="line_"></span>
              <span>{{ item.text }}{{ $t('common.require') }}</span>
            </div>
            <div class="i_div">
              {{ $t('common.sampleTip') }}
            </div>
            <div
              class="imgList"
              v-if="item.templateList && item.templateList.length != 0"
            >
              <img
                v-for="(img, index) in item.templateList"
                :key="'sam' + index"
                :src="img.templateUrl"
                alt=""
              />
            </div>
            <div class="imgList textcenter" v-else>暂无示例图片</div>
            <div
              class="cardBtn_"
              style="z-index: 100"
              @click="hideSample(item)"
            >
              {{ $t('btn.know') }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="upload_" v-if="isShowSignPreview && type == 'claimUpload'">
      <div class="upload_1">
        <p style="margin: 20px 0">{{ $t('noticeArr[9]') || '电子签名预览' }}</p>
        <div class="sign_">
          <img :src="signImg" alt="" />
        </div>
      </div>
    </div>
    <div
      class="cardBtn_ test"
      @click="handleNext"
      style="z-index: 99; cursor: pointer"
      v-if="(step == '2' || claimStep == '4') && nextP"
    >
      {{ $t('btn.nextPage') }}
    </div>
    <div class="mask" v-show="visible" @click.self="visible = false">
      <div class="img-box">
        <img :src="previewUrl" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    // 类型
    type: {
      type: String,
      default: ''
    },
    // 列表数据
    list: {
      type: Array,
      default: () => []
    },
    // 是否预览
    preview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false, // 是否显示预览遮罩
      previewUrl: '', // 预览的图片链接
      claimUpload: [],
      MGUChecked: false, //mGu用户选择是否上传文件
      isMGU: false,
      signImg: '',
      action: {
        target: '//jsonplaceholder.typicode.com/photos/',
        prop: 'base64Value'
      },
      files: [],
      uploadList: [],
      uploadParamsList: [], // 图片上传参数列表
      uploadList1: [],
      uploadList2: [],
      uploadList3: []
    }
  },
  watch: {
    list(val) {
      console.log('watch list -> ', val)
      this.uploadList = val
    }
  },
  computed: {
    ...mapState({
      step: (state) => state.common.step,
      nextP: (state) => state.common.nextP,
      edit: (state) => state.common.edit,
      claimEdit: (state) => state.common.claimEdit,
      claimStep: (state) => state.common.claimStep
    }),
    isShowSignPreview() {
      let form = JSON.parse(sessionStorage.getItem('claimForm'))
      let isMGU = 'N'
      if (form && form.memberNo) {
        let list_ = JSON.parse(localStorage.getItem('employeeInfoList'))
        let new_arr = []
        list_.map((item) => {
          new_arr.push(item)
          if (item.subCardList && item.subCardList.length > 0) {
            item.subCardList.map((item1) => {
              new_arr.push(item1)
            })
          }
        })
        let filter = new_arr.filter((item) => item.memberNo == form.memberNo)[0]
        isMGU = filter ? filter.is_mgu : 'N'
      }
      return isMGU == 'Y' && (this.claimStep == '5' || this.step == '3')
    }
  },
  mounted() {
    this.getItem()
    this.getMemberInfoFile()
    if (this.isShowSignPreview) {
      this.claimUpload = sessionStorage.getItem('claimUpload')
      this.getSignUploadParams()
      this.isMGU = true
    }
  },
  methods: {
    getSignUploadParams() {
      //判断用户是否为MGU,从而预览时是否显示签名
      this.uploadParamsList = JSON.parse(sessionStorage.getItem('uploadParams'))
      if (this.uploadParamsList) {
        this.uploadParamsList.map((item) => {
          if (item.imageType == 'SIGN') {
            this.signImg = item.imagStr
          }
        })
      }
      console.log(
        this.uploadList,
        this.claimEdit,
        this.claimStep,
        'getSignUploadParams'
      )
    },
    changeSwitch(val) {
      console.log(val)
      this.MGUChecked = val
      sessionStorage.setItem('isM', val)
      if (this.MGUChecked == false) {
        if (
          this.uploadList.findIndex((item) => item.imageType == 'OPC') != -1
        ) {
          this.uploadList[
            this.uploadList.findIndex((item) => item.imageType == 'OPC')
          ].list = []
        }
        let list = JSON.parse(sessionStorage.getItem('claimUpload'))
        let list_1 = JSON.parse(sessionStorage.getItem('uploadParams'))
        list.map((item) => {
          if (item.imageType == 'OPC' && item.list && item.list.length > 0) {
            item.list = []
          }
        })
        sessionStorage.setItem('claimUpload', JSON.stringify(list))
        if (list_1.findIndex((item) => item.imageType == 'OPC') != -1) {
          let index = list_1.findIndex((item) => item.imageType == 'OPC')
          list_1.slice(index, 1)
          sessionStorage.setItem('uploadParams', JSON.stringify(list_1))
        }
      }
    },
    getMemberInfoFile() {
      let this_ = this
      const memberNo = this.$utils.getMemberInfo().memberNo
      if (!memberNo) return
      this.$apis
        .getMemberInfoFile(memberNo)
        .then((res) => res.data)
        .then((res) => {
          let item = this_.uploadList.find((item) => {
            return item.type == 'PC'
          })
          console.log(
            this.uploadList,
            this.claimEdit,
            this.claimStep,
            'getMemberInfoFile'
          )
          if (item) {
            item.list = res.data.map((item) => {
              return {
                url: item
              }
            })
          }
        })
    },
    getItem() {
      let list
      if (this.type == 'preAuthUpload') {
        list = sessionStorage.getItem('preAuthUpload')

        if (!list) {
          this.getFileType('AUTH')
        } else {
          this.uploadList = JSON.parse(list)
        }
      } else if (this.type == 'claimUpload') {
        list = sessionStorage.getItem('claimUpload')
        if (!list) {
          this.getFileType('LPSQ')
        } else {
          this.uploadList = [...JSON.parse(list)]
          if (
            this.uploadList.findIndex(
              (item) => item.type == 'OPC' && item.list.length > 0
            ) != -1
          ) {
            this.MGUChecked = true
            sessionStorage.setItem('isM', true)
          } else if (
            this.uploadList.findIndex(
              (item) =>
                item.type == 'OPC' && (item.list.length == 0 || !item.list)
            ) != -1
          ) {
            this.MGUChecked = false
            sessionStorage.setItem('isM', false)
          }
        }
        console.log(this.uploadList, this.claimEdit, this.claimStep, 'getItem')
      } else if (this.type == 'supplyMaterialUpload' && this.preview != true) {
        this.getSupply()
      }
    },
    //兼容老用户
    getFileType(type) {
      //获取上传资料
      console.log('兼容----')
      const userInfo = this.$utils.getUserInfo()
      let data = {
        applyType: type,
        payorCode: userInfo.payorCode
      }
      this.$apis.getFileType(data).then((res) => {
        this.saveClaimUpload(res.data.data)
      })
    },
    saveClaimUpload(data) {
      //保存理赔上传材料的参数
      let key = 'cName'
      let note = 'cNote'
      console.log(this.$i18n.locale, 366)
      if (this.$i18n.locale == 'en-us') {
        key = 'eName'
        note = 'eNote'
      }
      //资料上传处所需初始列表存储
      let arr = []
      data.map((item) => {
        arr.push({
          ...item,
          imageType: item.type,
          text: item[key],
          mynote: item[note],
          list: [],
          showSample: false
        })
      })
      this.uploadList = [...arr]
      sessionStorage.setItem('claimUpload', JSON.stringify(arr))
    },

    getSupply() {
      let mylist = JSON.parse(localStorage.getItem('supplyMaterialUpload'))
      this.uploadList = mylist
    },
    showSample(item) {
      item.showSample = true
    },
    hideSample(item) {
      item.showSample = false
    },
    showImagePreview(item) {
      this.previewUrl = item.imageUrl
      this.visible = true
      console.log(this.previewUrl)
    },
    showToast(text, eText) {
      let content = text
      if (this.$i18n.locale == 'en-us') {
        content = eText
      }
      this.toast = this.$createToast({
        txt: content,
        type: 'txt'
      })
      this.toast.show()
    },
    handleNext() {
      let arr = this.uploadList
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].isFill == '1' && arr[i].list.length == 0) {
          this.showToast('请上传' + arr[i].cName, 'upload ' + arr[i].eName)
          return false
        }
      }
      this.saveUpData()
      this.submitData()
    },
    saveUpData() {
      //上传页面保存数据
      try {
        if (this.type == 'preAuthUpload') {
          sessionStorage.setItem(
            'preAuthUpload',
            JSON.stringify(this.uploadList)
          )
        } else if (this.type == 'claimUpload') {
          sessionStorage.setItem('claimUpload', JSON.stringify(this.uploadList))
        } else if (this.type == 'supplyMaterialUpload') {
          localStorage.setItem(
            'supplyMaterialUpload',
            JSON.stringify(this.uploadList)
          )
        }
      } catch (err) {
        console.log(err)
      }
    },
    submitData() {
      //上传页面数据提交后的操做，预授权与理赔跳转
      if (this.type == 'preAuthUpload') {
        this.$store.commit('common/setStep', '3')
        this.$store.commit('common/setEdit', false)
        this.$router.push({
          name: 'preAuthApply',
          query: {
            //参数s为步骤，e为是否编辑，在main。js里接收
            s: 3,
            e: false
          }
        })
      } else if (this.type == 'claimUpload') {
        let form = JSON.parse(sessionStorage.getItem('claimForm'))
        let isMGU = 'N'
        if (form && form.memberNo) {
          let list_ = JSON.parse(localStorage.getItem('employeeInfoList'))
          let new_arr = []
          list_.map((item) => {
            new_arr.push(item)
            if (item.subCardList && item.subCardList.length > 0) {
              item.subCardList.map((item1) => {
                new_arr.push(item1)
              })
            }
          })
          let filter = new_arr.filter(
            (item) => item.memberNo == form.memberNo
          )[0]
          isMGU = filter ? filter.is_mgu : 'N'
        }
        localStorage.setItem('isMGU', isMGU)
        if (
          this.MGUChecked == true &&
          this.uploadList.findIndex(
            (item) =>
              item.type == 'OPC' && (item.list.length == 0 || !item.list)
          ) != -1
        ) {
          this.showToast(
            '请上传保险计划的副本',
            'Please provide a copy of the policy'
          )
          return
        }
        if (isMGU == 'Y') {
          localStorage.setItem('count', 1)
          this.$router.push({
            path: '/zjd/esign'
          })
        } else {
          //跳转理赔第4步
          this.$store.commit('common/setClaimStep', '5') //更改全局值
          this.$store.commit('common/setClaimEdit', false)
          this.$router.push({
            //保留历史记录
            name: 'claimApply',
            query: {
              s: 5,
              e: false
            }
          })
        }
      }
    },
    fileRemove(file, item) {
      console.log(file, '取消文件', item)
      this.uploadParamsList.map((ele, i) => {
        if (ele.imageType == item.imageType && file.name == ele.imageName) {
          this.uploadParamsList.splice(i, 1)
        }
      })
      sessionStorage.setItem(
        'uploadParams',
        JSON.stringify(this.uploadParamsList)
      )
    },
    processFile(file, next) {
      this.$utils.compress(
        file,
        {
          compress: {
            width: 1600,
            height: 1600,
            quality: 0.5
          }
        },
        next
      )
    },
    fileSubmitted(file, item) {
      console.log(file, '文件', item)
      let file_ = sessionStorage.getItem('uploadParams')
      this.uploadParamsList = file_ ? JSON.parse(file_) : []
      this.uploadParamsList.push({
        imagStr: file.base64,
        imageName: file.name,
        imageType: item.imageType
      })
      sessionStorage.setItem(
        'uploadParams',
        JSON.stringify(this.uploadParamsList)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.upPage_ {
  padding-bottom: 30px;
}
.mask {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  .img-box {
    max-width: 80vw;
    text-align: center;
    img {
      width: 100%;
    }
  }
}
.upload_ {
  .upload_1 {
    position: relative;
    padding: 0 36px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
    .sign_ {
      width: 305px;
      height: 131px;
      background: #f5f5f5;
      border-radius: 5px;
      img {
        height: 100%;
        width: 100%;
      }
    }
  }

  .text_ {
    margin: 10px 0;
    text-align: left;
    line-height: 16px;
  }

  .text_1 {
    font-size: 15px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 0;
  }

  .point {
    width: 5px;
    height: 5px;
    background: rgba(199, 162, 131, 1);
    border-radius: 50%;
    position: absolute;
    top: 15px;
    left: 20px;
  }

  .uploadImg {
    display: inline-block;
    background: #eee;
    overflow: hidden;
    width: 80px;
    height: 80px;
    margin-right: 5px;
  }

  .themeColor {
    font-size: 12px;
    color: rgba(199, 162, 131, 1);
  }
}

.cardBtn_ {
  margin-bottom: 20px;
  width: 305px;
  height: 50px;
  line-height: 50px;
  margin: 30px auto;
  background: rgba(51, 51, 51, 1);
  box-shadow: 0px 5px 15px 0px rgba(51, 51, 51, 0.3);
  border-radius: 5px;
  font-size: 15px;
  position: relative;
  color: rgba(255, 231, 166, 1);
}

.outer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  background: rgba(51, 51, 51, 0.3);

  .inner {
    background: #fff;
    position: absolute;
    border-radius: 15px;
    top: 30px;
    left: 10px;
    right: 10px;
    bottom: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    padding: 10px;

    .imgList {
      height: 400px;
      overflow-x: scroll;
      display: flex;
      width: 290px;

      img {
        height: auto;
        width: 290px;
        margin: 5px;
      }
    }

    .i_div {
      width: 280px;
      margin: 10px 0;
      margin-left: 40px;
      text-align: left;
      font-size: 13px;
      color: rgba(102, 102, 102, 1);
    }

    .i_div1 {
      font-size: 15px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      position: relative;

      .line_ {
        width: 3px;
        height: 16px;
        background: rgba(199, 162, 131, 1);
        border-radius: 2px;
        position: absolute;
        left: -10px;
        top: 0;
      }
    }
  }
}

.MGU_ {
  display: flex;

  .yes_ {
    width: 43px;
    height: 21px;
    line-height: 21px;
    background: #333333;
    border-radius: 11px;
    font-size: 13px;
    font-family: PingFang SC;
    color: #ffe7a6;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .no_ {
    background: #f5f5f5;
    color: #333333;
  }

  .boll {
    width: 14px;
    height: 14px;
    background: #ffe7a6;
    border-radius: 50%;
    display: inline-block;
  }

  .boll-no {
    background: #d8d8d8;
  }

  p {
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
    text-align: left;
    width: 89%;
    line-height: 20px;
  }
}

.textcenter {
  text-align: center;
  justify-content: center;
  margin-top: 30px;
}
</style>
